import React from "react";

const AutoImageSlider = ({ images, speed = 40 }) => {
  const duplicatedSlides = [...images, ...images, ...images];

  return (
    <div className="w-full overflow-hidden py-5 bg-transparent -mt-8 relative">
      <div className="w-full relative overflow-hidden">
        <div
          className="flex animate-scroll hover:pause"
          style={{
            width: `calc(${images.length * 400}px * 3)`,
            animationDuration: `${speed}s`,
          }}
        >
          {duplicatedSlides.map((slide, index) => (
            <div
              key={`${slide.id}-${index}`}
              className="w-[380px] h-[420px] flex-shrink-0 mx-3 bg-transparent rounded-none overflow-hidden flex flex-col
                         lg:w-[380px] lg:h-[420px]
                         md:w-[350px] md:h-[400px]
                         sm:w-[320px] sm:h-[380px] sm:mx-4
                         xs:w-[300px] xs:h-[350px] xs:mx-3 "
            >
              <div className="w-full flex-1 overflow-hidden flex items-center justify-center">
                <img
                  src={slide.src || slide.image}
                  alt={slide.title || slide.alt || `Slide ${slide.id}`}
                  className="w-full h-full object-cover object-center block border-2 border-red transition-transform duration-300 hover:scale-105"
                />
              </div>
              {slide.title && (
                <div className="w-full bg-red  text-white text-center py-2 ">
                  <p className="">{slide.title}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-380px * ${images.length}));
          }
        }

        .animate-scroll {
          animation: scroll ${speed}s linear infinite;
        }

        .hover\\:pause:hover {
          animation-play-state: paused;
        }

        @media (max-width: 1024px) {
          @keyframes scroll {
            100% {
              transform: translateX(calc(-350px * ${images.length}));
            }
          }
        }

        @media (max-width: 768px) {
          @keyframes scroll {
            100% {
              transform: translateX(calc(-320px * ${images.length}));
            }
          }
        }

        @media (max-width: 480px) {
          @keyframes scroll {
            100% {
              transform: translateX(calc(-300px * ${images.length}));
            }
          }
        }
      `}</style>
    </div>
  );
};

export default AutoImageSlider;
